import React, { Component } from 'react';
import { Row, Col, Table, Popover, OverlayTrigger } from "react-bootstrap";
import Select from 'react-select';
import { toast } from 'react-toastify';

import { CustomCard } from "../../../components/Card/CustomCard";
import { ConsultCarreras} from '../../../funciones/ModalidadesFunction';
import { ConsultaSemestres} from '../../../funciones/CalifDirFunction';
import { ConsultaSecciones } from "../../../funciones/CobranzasFunction";

import { EstudiantesxSecc } from '../../../funciones/AdministracionFunction';
import ModalReports from '../../../components/Reportes/ModalReports';
import ListInscritos from '../../../components/Reportes/ListInscritos';
import ListadoEstudiantesEA from '../../../components/Reportes/ListadoEstudiantesEA';

class Inscritos extends Component {
    state = {
        valorCarrera: { value: '', label: '- Selecciona una Carrera -' },
        carreras: [{ value: '', label: ' - Cargando Espere - ' }],
        valorSemestre: { value: '', label: '- Selecciona un Semestre -' },
        semestres: [],
        valorSeccion: { value: '', label: '- Selecciona una Sección -', datos:'' },
        secciones: [],
        preloader: <div className="text-danger">Selecciona una Carrera para comenzar</div>,

        estudiantes: [],
        openWR: false,
        openWRE: false
    }

    componentDidMount = () => {
        ConsultCarreras ((resp) => {
            this.setState({carreras: resp})
        })
    }

    valorSelectCarrera = (valorCarrera) => {
        this.setState({
            valorCarrera,
            valorSemestre: { value: '', label: '- Cargando Semestres -' },
            valorSeccion: { value: '', label: '- Selecciona una Sección -', datos:'' },
            secciones: [],
            preloader: <div className="text-danger">Selecciona una Semestre para continuar</div>,
        }, () => {
            ConsultaSemestres(valorCarrera.value, (resp) => {
                this.setState({
                    semestres: resp[0],
                    valorSemestre: { value: '', label: '- Selecciona un Semestre -' },
                })
            })
        });
    }

    valorSelectSemestre = (valorSemestre) => {
        this.setState({
            valorSemestre,
            valorSeccion: { value: '', label: '- Cargando Secciones -', datos:'' },
            estudiantes: [],
            preloader: <div className="text-danger">Selecciona una Sección para continuar</div>,
        }, () => {
            ConsultaSecciones(valorSemestre.value, (resp) => {
                this.setState({
                    secciones: resp[0],
                    valorSeccion: { value: '', label: '- Selecciona una Sección -', datos:resp.datos },
                })
            })
        });
    }

    valorSelectSeccion = (valorSeccion) => {
        this.setState({
            valorSeccion,
            preloader: <div className="text-danger"><i className="fa fa-spinner fa-spin"></i> Cargando Estudiantes</div>,
        }, () => {
            EstudiantesxSecc (valorSeccion.value, (resp) => {
                let prel = "" ;
                if (resp.length === 0) prel = "No existen coincidencias con la búsqueda seleccionada";

                this.setState({
                    estudiantes: resp,
                    preloader: prel,
                })
            })
        });
    }

    openReporte = () => {
        switch (true) {
            case (this.state.valorCarrera.value === ""):
                toast.error("Debes seleccionar la Carrera",{autoClose: 4000});
                break;
            case (this.state.valorSemestre.value === ""):
                toast.error("Debes seleccionar el Semestre",{autoClose: 4000});
                break;
            case (this.state.valorSeccion.value === ""):
                toast.error("Debes seleccionar la Sección",{autoClose: 4000});
                break;
            default:
                this.setState({openWR: true})
        }
    }

    openReporteE = () => {
        switch (true) {
            case (this.state.valorCarrera.value === ""):
                toast.error("Debes seleccionar la Carrera",{autoClose: 4000});
                break;
            case (this.state.valorSemestre.value === ""):
                toast.error("Debes seleccionar el Semestre",{autoClose: 4000});
                break;
            case (this.state.valorSeccion.value === ""):
                toast.error("Debes seleccionar la Sección",{autoClose: 4000});
                break;
            default:
                this.setState({openWRE: true})
        }
    }

    contenido = () => {
        let { valorCarrera, carreras, valorSemestre, semestres, valorSeccion, secciones, preloader, estudiantes, openWR } = this.state;

        const styles = {
            padding: 5, fontSize: 12
        }

        let EstIndTable = () => {
            let { estudiantes } = this.state;
            let num = 0;

            if(estudiantes.length === 0) return (
                <tr>
                    <td colSpan={5} align= "center" style={{padding: 5, fontSize: 12}}>
                        <div className="text-danger">No existen estudiantes en esta sección</div>
                    </td>
                </tr>
            )

            let nombre = (nomb) => {
                if (nomb === null) return "";
                return nomb
            }

            return (
                estudiantes.map(option => {
                    num++;
                    return (
                        <tr key={option.id}>
                            <td style={styles} align="center"><strong>{num}</strong></td>
                            <td style={styles}>{`${option.nacionalidad} ${option.ci}`}</td>
                            <td style={styles}>{`${option.nombre_1} ${nombre(option.nombre_2)}`}</td>
                            <td style={styles}>{`${option.apellido_1} ${nombre(option.apellido_2)}`}</td>
                        </tr>
                    )
                })
            )
        }

        let estadistica = () => {
            let M = 0;
            let F = 0;
            let total = estudiantes.length;

            for(let i in estudiantes){
                (estudiantes[i].sexo === "M") ? M++ : F++ ;
            }

            let porcentajeM = (M * 100) / total;
            let porcentajeF = (F * 100) / total;

            return (
                <React.Fragment>
                    <div className="custom-alert-warning custom-mt-10" style={{fontSize:10}}>Datos estadísticos de la sección <strong>{valorSeccion.label}</strong></div>
                    <Row className="custom-mt-10">
                        <Col md={2}>
                            <div style={{fontSize:10}} className="text-danger">Inscritos:</div>
                            <div style={{fontSize:10}} className="text-muted">({estudiantes.length}) estudiantes</div>
                        </Col>
                        <Col md={5}>
                            <div style={{fontSize:10}} className="text-danger">Femenino <span className="text-muted">({F}) estudiantes</span></div>

                            <div className="progress">
                                <div className="progress-bar" role="progressbar" aria-valuenow="70"
                                    aria-valuemin="0" aria-valuemax="100" style={{width: `${Math.round(porcentajeF)}%`, backgroundColor:"#A0555C"}}>
                                    {Math.round(porcentajeF)}%
                                </div>
                            </div>
                        </Col>
                        <Col md={5}>
                            <div style={{fontSize:10}} className="text-danger">Masculino <span className="text-muted">({M}) estudiantes</span></div>

                            <div className="progress">
                                <div className="progress-bar" role="progressbar" aria-valuenow="70"
                                    aria-valuemin="0" aria-valuemax="100" style={{width: `${Math.round(porcentajeM)}%`, backgroundColor:"#1f2f6e"}}>
                                    {Math.round(porcentajeM)}%
                                </div>
                            </div>
                        </Col>
                    </Row>
                </React.Fragment>
            )
        }

        let contentEst = () => {
            if (estudiantes.length === 0) return (
                <div className="custom-mt-10" align="center">{preloader}</div>
            )

            return (
                <React.Fragment>
                    <div>{estadistica()}</div>
                    <div className="custom-alert-info custom-mt-10" style={{padding: 5}}>
                        <div className="table-responsive" id="lisEstDeuda" onScroll={this.update} style={{overflowY: "auto", maxHeight: "30vh"}}>
                            <Table striped hover bordered>
                                <tbody>
                                    <tr className="custon-back-color">
                                        <td width="15px" style={styles}><strong>N°</strong></td>
                                        <td width="20%" align="center" style={styles}><strong>Cédula</strong></td>
                                        <td width="80%" colSpan={2} align="center" style={styles}><strong>Estudiante</strong></td>
                                    </tr>
                                    {EstIndTable()}
                                </tbody>
                            </Table>
                        </div>
                    </div>
                </React.Fragment>
            )
        }

        let styles2 = {
            cursor:"pointer",
            paddingTop:5,
            paddingBottom:5,
        }

        let printList = (
            <Popover>
                <div className="text-danger" style={styles2} onClick={this.openReporte}><i className="fa fa-university"></i> Alumnos por materia</div>
                <div className="text-danger" style={styles2} onClick={this.openReporteE}><i className="fa fa-university"></i> Alumnos por materia (Con Email)</div>
            </Popover>
        )

        return (
            <React.Fragment>
                <div className="custom-alert-info">
                    <Row>
                        <Col md={6}>
                            <Select
                                isSearchable ={true}
                                value={valorCarrera}
                                onChange={this.valorSelectCarrera}
                                options={carreras}
                            />
                            <span className="text-muted" style={{fontSize: 10}}>Carreras</span>
                        </Col>
                        <Col md={6}>
                            <Select
                                isSearchable ={true}
                                value={valorSemestre}
                                onChange={this.valorSelectSemestre}
                                options={semestres}
                            />
                            <span className="text-muted" style={{fontSize: 10}}>Semestres</span>
                        </Col>
                    </Row>
                </div>
                <div className="custom-alert-warning custom-mt-10">
                    <Row>
                        <Col md={9}>
                            <Select
                                isSearchable ={true}
                                value={valorSeccion}
                                onChange={this.valorSelectSeccion}
                                options={secciones}
                            />
                            <span className="text-muted" style={{fontSize: 10}}>Secciones Disponibles</span>
                        </Col>
                        <Col md={3} align="right">
                            <OverlayTrigger trigger="focus" placement="bottom" overlay={printList}>
                                <button className="btn btn-relleno-danger" title="Opciones de Impresión" style={{borderWidth: 1, marginTop:5}}><i className="fa fa-print"></i> Imprimir<i className="fa fa-caret-down"></i></button>
                            </OverlayTrigger>
                        </Col>
                    </Row>
                </div>
                <div className="custom-mt-10">{contentEst()}</div>
            </React.Fragment>
        )
    }

    ayuda = () => (
        <Row>
            <Col md={12} align="justify">
                Para ver el listado de estudiantes debes seleccionar <strong>La Carrera</strong>, <strong>El Semestre</strong> y <strong>La Sección</strong>
            </Col>

            <Col md={12} align="justify" className="custom-mt-10">
                <div className="custom-alert-warning">Datos estadísticos...</div>
            </Col>
            <Col md={12} align="justify" className="custom-mt-10">
                <div>En esta área encontrarás detalles de la sección respecto a la cantidad de estudiantes inscritos, separados por masculinos y femeninos con una barra indicadora del porcentaje total para cada género.</div>
            </Col>

            <Col md={5} align="justify" className="custom-mt-10">
                <div className="progress">
                    <div className="progress-bar" role="progressbar" aria-valuenow="70"
                        aria-valuemin="0" aria-valuemax="100" style={{width: "35%", backgroundColor:"#A0555C"}}>
                        35%
                    </div>
                </div>
            </Col>
            <Col md={7} align="justify" className="custom-mt-10">
                Corresponde a los estudiantes femeneninos inscritos.
            </Col>

            <Col md={5} align="justify" className="custom-mt-10">
                <div className="progress">
                    <div className="progress-bar" role="progressbar" aria-valuenow="70"
                        aria-valuemin="0" aria-valuemax="100" style={{width: "65%", backgroundColor:"#1f2f6e"}}>
                        65%
                    </div>
                </div>
            </Col>
            <Col md={7} align="justify" className="custom-mt-10">
                Corresponde a los estudiantes masculinos inscritos.
            </Col>

            <Col md={12} align="justify" className="custom-mt-10">
                <div>También tienes a disposición el listado de estudiantes inscritos para la sección seleccionada con sus nombres y apellidos.</div>
            </Col>

            <Col md={12} align="justify" className="custom-mt-10">
                <div><strong style={{color:"#1f2f6e"}}>Impresión</strong></div>
            </Col>
            <Col md={12} align="justify" className="custom-mt-10">
                El botón <button className="btn btn-relleno-danger btn-xs" style={{borderWidth: 1, fontSize:10}}><i className="fa fa-print"></i> Imprimir</button> permite ver los listados disponibles para la impresión
            </Col>
        </Row>
    )

    modalReporte = () => {
        let { openWR, estudiantes, valorSeccion } = this.state;
        if (openWR === false ) return null;

        return (
            <ModalReports
                reporte={<ListInscritos datos = {estudiantes} seccion ={valorSeccion.datos}/>}
                titulo={`Listado de Estudiantes Inscritos`}
                display= "block"
                cerrar = {() => {this.setState({openWR: false})}}
            />
        )
    }

    modalReporteE = () => {
        let { openWRE, estudiantes, valorSeccion } = this.state;
        if (openWRE === false ) return null;

        return (
            <ModalReports
                reporte={<ListadoEstudiantesEA estudiantes = {estudiantes} seccion ={valorSeccion.datos}/>}
                titulo={`Listado de Estudiantes Inscritos`}
                display= "block"
                cerrar = {() => {this.setState({openWRE: false})}}
            />
        )
    }

    render() {
        return (
            <div className="content">
                <Row>
                    <Col md={8}>
                        {this.contenido()}
                    </Col>
                    <Col md={4}>
                        <div style={{borderRadius: "4px 4px",}}>
                            <CustomCard
                                styles ={{backgroundColor: "#1f2f6e", borderTopLeftRadius: 4, borderTopRightRadius: 4,}}
                                title={<span style={{color: "#fff"}}><i className="pe-7s-help1"></i> Ayuda</span>}
                                category={<span style={{color: "#fff"}}>Alumnos Inscritos</span>}
                                color="#a80012"
                                content={this.ayuda()}
                            />
                        </div>
                    </Col>
                </Row>
                {this.modalReporte()}
                {this.modalReporteE()}
            </div>
        );
    }
}
 
export default Inscritos;


// WEBPACK FOOTER //
// ./src/views/Administracion/ReinscripcionesContent/Inscritos.jsx